import redirectInterceptor from "@/interceptors/redirect_interceptor";

const getDefaultState = () => {
  return {
    voyageAuxEnginesData: null,
    fetchAuxEnginesDataLoading: true,
  };
};

const state = getDefaultState();

const getters = {
  firstAuxEngineRunningHours: (state) => {
    return _generateAuxRHPSeriesData(state, "Aux 1", "Running Hours");
  },
  secondAuxEngineRunningHours: (state) => {
    return _generateAuxRHPSeriesData(state, "Aux 2", "Running Hours");
  },
  thirdAuxEngineRunningHours: (state) => {
    return _generateAuxRHPSeriesData(state, "Aux 3", "Running Hours");
  },
  firstAuxEnginePower: (state) => {
    return _generateAuxRHPSeriesData(state, "Aux 1", "Power");
  },
  secondAuxEnginePower: (state) => {
    return _generateAuxRHPSeriesData(state, "Aux 2", "Power");
  },
  thirdAuxEnginePower: (state) => {
    return _generateAuxRHPSeriesData(state, "Aux 3", "Power");
  },
  interval: (state) => {
    if (state.voyageAuxEnginesData === null) {
      return 0;
    }
    return Math.ceil(
      (new Date(state.voyageAuxEnginesData.stopDate) -
                new Date(state.voyageAuxEnginesData.startDate)) /
            (1000 * 60 * 60 * 24)
    );
  },
  runningHoursChartOptions: (state, getters) => {
    const firstAuxSeries = _generateRHPChartSeries("Aux 1", getters.firstAuxEngineRunningHours);
    const secondAuxSeries = _generateRHPChartSeries("Aux 2", getters.secondAuxEngineRunningHours);
    const thirdAuxSeries = _generateRHPChartSeries("Aux 3", getters.thirdAuxEngineRunningHours);

    return _generateRHPChartOptions([firstAuxSeries, secondAuxSeries, thirdAuxSeries], "Running Hours [hr]", getters.interval);
  },
  powerChartOptions: (state, getters) => {
    const firstAuxSeries = _generateRHPChartSeries("Aux 1", getters.firstAuxEnginePower);
    const secondAuxSeries = _generateRHPChartSeries("Aux 2", getters.secondAuxEnginePower);
    const thirdAuxSeries = _generateRHPChartSeries("Aux 3", getters.thirdAuxEnginePower);

    return _generateRHPChartOptions([firstAuxSeries, secondAuxSeries, thirdAuxSeries], "Power [kw]", getters.interval);
  }
};

const actions = {
  async fetchVoyageAuxRHP({ commit }, data) {
    commit("SET_FETCH_AUX_ENGINES_DATA_LOADING", true);
    const url = `${localStorage.getItem("basicUrl")}/vesselInformation/${data.name}/voyageAuxRHP`;

    const response = await redirectInterceptor.get(url, {
      params: {
        startDate: data.startDate,
        stopDate: data.stopDate
      },
      headers: {
        Authorization: localStorage.getItem("quad_token")
      }
    });
    if (response.status === 200) {
      commit("SET_VOYAGE_AUX_ENGINES_DATA", response.data);
    } else {
      commit("SET_VOYAGE_AUX_ENGINES_DATA", null);
    }
  },
};

const mutations = {
  SET_FETCH_AUX_ENGINES_DATA_LOADING: (state, loading) => (state.fetchAuxEnginesDataLoading = loading),
  SET_VOYAGE_AUX_ENGINES_DATA: (state, data) => (state.voyageAuxEnginesData = data, state.fetchAuxEnginesDataLoading = false)
};

function _generateRHPChartSeries(name, data) {
  return {
    name: name,
    type: "column",
    data: data,
    marker: {
      enabled: false,
    },
    animation: false,
    states: {
      hover: {
        enabled: false,
      },
      normal: {
        animation: false,
      },
      inactive: {
        opacity: 1,
      },
    },
    visible: true,
  };
}

function _generateRHPChartOptions(series, yAxisText, interval) {
  return {
    credits: {
      enabled: false,
    },
    time: {
      useUTC: true,
    },
    title: {
      text: undefined,
    },
    tooltip: {
      formatter: function () {
        let tooltip =
                    "<b>" + new Date(this.x).toISOString().slice(0, 10) + "</b>";

        const unique = [
          ...new Set(this.points.map((item) => item.series.name)),
        ];

        unique.forEach((s) => {
          tooltip = tooltip + "<br/>" + s + " : ";

          const temp = this.points.filter((item) => item.series.name === s);

          temp.forEach((t) => {
            if (t.series.index % 2 === 0)
              tooltip = tooltip + t.y + " [hr] - ";
            else tooltip = tooltip + t.y + " [kW]";
          });
        });

        return tooltip;
      },
      shared: true,
    },
    yAxis: {
      gridLineWidth: 2,
      title: {
        text: yAxisText,
        align: "high",
      },
      max: yAxisText === "Running Hours [hr]" ? 24 : null,
    },
    xAxis: {
      type: "datetime",
      title: {
        //text:'Time',
        align: "high",
      },
      labels: {
        format: "{value:%e %b %Y}",
      },
      tickInterval: 24 * 3600 * 1000 * Math.ceil(interval / 3),
      crosshair: true,
    },
    exporting: {
      enabled: false,
    },
    legend: {
      layout: "horizontal",
      align: "right",
      verticalAlign: "top",
      floating: false,
    },
    series: series,
  };

}

function _mapSeriesData(series) {
  return series.map((datum) => {
    try {
      return [new Date(datum[0]).getTime(), Number(datum[1])];
    }
    catch (e) {
      return [];
    }
  });
}

function _generateAuxRHPSeriesData(state, engine, dataType) {
  try {
    return state.voyageAuxEnginesData !== null
      ? _mapSeriesData(state.voyageAuxEnginesData[engine][dataType])
      : [];
  } catch (e) {
    return [];
  }
}

export const voyageAuxEnginesModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
